import React from 'react';
import { Map } from 'immutable';
import moment from 'moment';
import classNames from 'classnames';
import {
    TableWrapper,
    TableHeaderRow,
    TableRow,
    ColumnHeader,
    TableCell,
    ChevronDownWrapper,
    TableSelectCellClickable,
    SectionMessage,

    RowWithTable,
    InnerTable,
    TableRowAddColor,
    CustomerTab
} from 'src/components/FraudAndCompliance/FraudAndCompliancesTab/FraudAndCompliances/components/MatchedAccount.style';
import { ChevronDownIconWrapper, Select, SelectWrapper } from './CommonTable.styles';

const ACTIONS = {
    'your': [
        { action: 'cancel', name: 'Mark as reviewed' },
        { action: 'unassign', name: 'Unassign' }
    ],
    'none': [
        { action: 'assign', name: 'Assign to me' }
    ],
    'other': [
        { action: 'unassign', name: 'Unassign' }
    ]
};

interface OptionType {
    action: string,
    name: string
}

const getOption = (state: OptionType, id: string): React.ReactElement => {
    return (
        <option
            key={`${id}-${state.action}`}
            value={state.action}
        >
            {state.name}
        </option>
    );
};

type ActionsType = 'your' | 'none' | 'other';
interface DataListType {
    accountId: number,
    accountName: string,
    assignee: { id: number, type: string, name: string },
    channels: Array<string>,
    createdAt: string,
    details: { matchedData: Array<string>, types: Array<string>, accounts: Array<{ id: number, type: string, name: string }> },
    id: string,
    status: string,
    type: string,
    universeId: string,
}

type DataType = Immutable.Map<any, any> | Immutable.List<DataListType>;
interface PropsType {
    type: ActionsType,
    status: string,
    className: string,
    onCancelRequest: (matchedAccount: unknown) => void,
    onAssignRequest: (matchedAccount: unknown) => void,
    onUnassignRequest: (matchedAccount: unknown) => void,
    onOpenAccountRequest: (id: number, name: string) => void,
    data: DataType
}
interface StateType {
    rows: Array<number>
}

export class MatchedAccount extends React.Component<PropsType, StateType> {

    static defaultProps = {
        className: ''
    };

    constructor(props: PropsType) {
        super(props);
        this.state = {
            rows: []
        };
    }

    openAccount(id: number, name: string): void {
        this.props.onOpenAccountRequest(id, name);
    }

    toggle(id: number) {
        const { rows } = this.state;

        //@ts-expect-error
        return (e) => {
            e.preventDefault();
            const index = rows.indexOf(id);
            if (index > -1) {
                rows.splice(index, 1);
            } else {
                rows.push(id);
            }

            this.setState({
                rows
            });
        };
    }

    //@ts-expect-error
    doAction = (e, matchedAccount) => {
        const action = e.target.value;

        const { onCancelRequest, onAssignRequest,
            onUnassignRequest } = this.props;
        if (action === 'unassign') {
            return onUnassignRequest(matchedAccount);
        } else if (action === 'assign') {
            return onAssignRequest(matchedAccount);
        } else if (action === 'cancel') {
            return onCancelRequest(matchedAccount);
        }
    };

    //@ts-expect-error
    renderRow(matchedAccount, rows: Array<number>, type: ActionsType): React.ReactNode {
        const id = matchedAccount.get('id');

        return (
            <TableRow key={id} section={type} data-test={`matched-account-row-${matchedAccount.get('accountId')}`} >
                <RowWithTable colSpan={6}>
                    <InnerTable>
                        <tbody>
                            <TableRowAddColor>
                                <TableSelectCellClickable
                                    onClick={this.toggle(matchedAccount.get('accountId'))}
                                    data-test={'matched-account-show-button'}
                                >
                                    <ChevronDownWrapper
                                        isCollapsed={rows.indexOf(matchedAccount.get('accountId')) !== -1}
                                    />
                                </TableSelectCellClickable>
                                <TableCell>{moment(matchedAccount.get('createdAt')).format('DD-MM-YYYY HH:mm')}</TableCell>
                                <TableCell data-test='matched-account-matched-data'>
                                    {matchedAccount.getIn(['details', 'matchedData']) &&
                                        matchedAccount.getIn(['details', 'matchedData']).map((m: string, i: number) => {
                                            return <span key={`${m}-${i}`}>{m}</span>;
                                        })}
                                </TableCell>
                                <TableCell>
                                    {matchedAccount.getIn(['details', 'types']) &&
                                        matchedAccount.getIn(['details', 'types']).map((t: string, i: number) => {
                                            return <span key={`${t}-${i}`}>{t}</span>;
                                        })}
                                </TableCell>
                                <TableCell>{matchedAccount.getIn(['details', 'accounts'], Map()).size}</TableCell>
                                <TableCell disableColor={true}>
                                    <SelectWrapper>
                                        <Select name='action' onChange={(e: React.SyntheticEvent): void => this.doAction(e, matchedAccount)} data-test='matched-account-action' >
                                            <option>Choose an action</option>
                                            {ACTIONS[type].map(state => getOption(state, id))}
                                        </Select>
                                        <ChevronDownIconWrapper />
                                    </SelectWrapper>
                                </TableCell>
                            </TableRowAddColor>
                            {rows.indexOf(matchedAccount.get('accountId')) !== -1 ?
                                <TableRowAddColor key={matchedAccount.get('id') + '-expanded'}>
                                    <td></td>
                                    <td colSpan={5} className={'table-row-opened'}>
                                        <div className={'contents'}>
                                            {
                                                //@ts-expect-error
                                                matchedAccount.getIn(['details', 'accounts']).map((account, index: number) => {
                                                    let cls = classNames('customerTab', {
                                                        'customerTabBold': +account.get('id') ===
                                                            matchedAccount.get('accountId')
                                                    });
                                                    return (
                                                        <CustomerTab className={cls}
                                                            key={`${account.get('id')}-${index}`}
                                                            onClick={() =>
                                                                this.openAccount(account.get('id'), account.get('name'))}>
                                                            <span className={'status online'}></span>
                                                            {account.get('name')}
                                                            <br />
                                                            <span className={'customerId'}>{account.get('id')}</span>
                                                            <br />
                                                            {account.get('type')}
                                                            <span className={'tag'}></span>
                                                        </CustomerTab>
                                                    );
                                                })
                                            }
                                        </div>
                                    </td>
                                </TableRowAddColor> : null
                            }
                        </tbody>

                    </InnerTable>

                </RowWithTable>
            </TableRow>
        );
    }

    render(): JSX.Element {
        const { data, type, status } = this.props;
        const { rows } = this.state;
        const areNoItems = status === 'FINISHED' && data.size === 0;

        return (
            <div>
                {areNoItems ? <SectionMessage>There are no items</SectionMessage> :
                    <TableWrapper>
                        <thead>
                            <TableHeaderRow>
                                <ColumnHeader></ColumnHeader>
                                <ColumnHeader>Date Detected</ColumnHeader>
                                <ColumnHeader>Matched Data</ColumnHeader>
                                <ColumnHeader>Types</ColumnHeader>
                                <ColumnHeader>Number of Accounts</ColumnHeader>
                                <ColumnHeader>Action</ColumnHeader>
                            </TableHeaderRow>
                        </thead>
                        <tbody>
                            {data.map(d => this.renderRow(d, rows, type)).toArray()}
                        </tbody>
                    </TableWrapper>
                }
            </div>
        );
    }
}
